export default {
  getMenuClickControlModalData(state) {
    return state.menuClickControlModalData;
  },
  getCatalogModalDeleteRowId(state) {
    return state.catalogModalDeleteRowId;
  },
};
